var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fm-radio",class:{
  'fm-radio-checked': _vm.currentValue,
  'fm-radio-disabled': this.disabled === undefined || this.disabled === true
}},[_c('label',[_c('input',{ref:"radio",attrs:{"type":"radio","disabled":this.disabled === undefined || this.disabled === true,"name":_vm.groupName},domProps:{"checked":_vm.currentValue,"value":_vm.value},on:{"change":_vm.change}}),_c('i',{staticClass:"fmico fmico-radio-checked"}),_c('i',{staticClass:"fmico fmico-radio"}),_c('span',{staticClass:"fm-radio-label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }